import { t as o, c as s } from "./format-DF9p-6BI.mjs";
function f(n, e) {
  const t = o(n);
  return isNaN(e) ? s(n, NaN) : (e && t.setDate(t.getDate() + e), t);
}
function u(n, e) {
  const t = o(n);
  if (isNaN(e)) return s(n, NaN);
  if (!e)
    return t;
  const a = t.getDate(), r = s(n, t.getTime());
  r.setMonth(t.getMonth() + e + 1, 0);
  const i = r.getDate();
  return a >= i ? r : (t.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    a
  ), t);
}
export {
  u as a,
  f as b
};
